import {
  CustomerDetailsCard,
  JobDetailsCard,
  MileageModal,
  OrderHeaderCards,
  OrderInvoiceCard,
  OrderPresenceAlert,
  OrderTabs
} from '@components';
import { useStore } from '@stores';
import { observer } from 'mobx-react';
import { useRef, useState } from 'react';

export const OrderView = observer(() => {
  const { orderStore, vehicleStore, authenticationStore } = useStore();
  const { order } = orderStore;
  const vehicle = vehicleStore.vehicle;
  const userRole = authenticationStore.currentUser?.role;

  const [activeKey, setActiveKey] = useState('Job details');
  const [openMileageModal, setOpenMileageModal] = useState(false);

  const shouldHideManagerFeatures = userRole === 'Technician';

  const tabsRef = useRef<HTMLDivElement>(null);

  const handleTabChange = (newActiveKey: string) => {
    setActiveKey(newActiveKey);
  };

  if (!order || !vehicle) return null;

  const jobCard = <JobDetailsCard />;

  const customerCard = (
    <CustomerDetailsCard
      compact
      customer={order.customer}
      vehicle={vehicle}
      onOpenChat={() => handleTabChange('Chat')}
    />
  );

  const invoiceCardContent = (
    <OrderInvoiceCard order={order} vehicle={vehicle} iconOnly />
  );

  return (
    <>
      <OrderPresenceAlert orderId={order?.id} />

      {!shouldHideManagerFeatures && (
        <OrderHeaderCards
          jobCard={jobCard}
          customerCard={customerCard}
          invoiceCard={invoiceCardContent}
        />
      )}

      <OrderTabs
        order={order}
        vehicle={vehicle}
        activeTabKey={activeKey}
        currentMileage={order.mileage}
        tabsRef={tabsRef}
        onTabChange={handleTabChange}
      />

      <MileageModal
        orderId={order.id}
        vin={vehicle.combinedVin}
        mileage={order.mileage}
        customerId={order.customerId}
        open={openMileageModal}
        setOpen={setOpenMileageModal}
        onCancel={() => setOpenMileageModal(false)}
      />
    </>
  );
});
